import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

export const CheveronRightCircleIcon = ({
  fill,
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 44 44"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-5 relative"
    {...restProps}
  >
    <path
      fill={fill}
      className={`fill-primary dark:${
        isActive ? "fill-primary" : "fill-caption group-hover:fill-primary"
      }`}
      fillRule="evenodd"
      d="M17.9688 34.0938C18.1452 34.0939 18.32 34.0592 18.483 33.9917C18.6461 33.9241 18.7942 33.825 18.9188 33.7L29.6688 22.95C29.7936 22.8253 29.8927 22.6772 29.9603 22.5142C30.0278 22.3512 30.0626 22.1765 30.0626 22C30.0626 21.8235 30.0278 21.6488 29.9603 21.4858C29.8927 21.3228 29.7936 21.1747 29.6688 21.05L18.9188 10.3C18.3937 9.7749 17.5435 9.7749 17.0187 10.3C16.494 10.825 16.4936 11.6753 17.0187 12.2L26.8187 22L17.0187 31.8C16.8939 31.9247 16.7948 32.0728 16.7272 32.2358C16.6597 32.3988 16.6249 32.5735 16.6249 32.75C16.6249 32.9265 16.6597 33.1012 16.7272 33.2642C16.7948 33.4272 16.8939 33.5753 17.0187 33.7C17.1433 33.825 17.2914 33.9241 17.4545 33.9917C17.6175 34.0592 17.7923 34.0939 17.9688 34.0938ZM0.5 22C0.5 10.1451 10.1451 0.5 22 0.5C33.8549 0.5 43.5 10.1451 43.5 22C43.5 33.8549 33.8549 43.5 22 43.5C10.1451 43.5 0.5 33.8549 0.5 22ZM3.1875 22C3.1875 32.3734 11.6266 40.8125 22 40.8125C32.3734 40.8125 40.8125 32.3734 40.8125 22C40.8125 11.6266 32.3734 3.1875 22 3.1875C11.6266 3.1875 3.1875 11.6266 3.1875 22Z"
    />
  </svg>
);
export default CheveronRightCircleIcon;
